export class DocumentHelper {
	static whenFontsAreLoaded(): Promise<FontFaceSet> {
		return document.fonts.ready;
	}
}
